import { MultiSelectTitleCardsList } from "Components/SelectableCard/MultiSelectTitleCard";
import { Flex, Typography } from "antd";

const allAreasOfHelp = [
  {
    title: "Test Prep",
    value: "Tests Preparation",
  },
  {
    title: "Counseling",
    value: "Counselor",
  },
  {
    title: "Applications",
    value: "Application Prep",
  },
  {
    title: "Loans",
    value: "Loan",
  },
  {
    title: "Visa",
    value: "Visa Prep",
  },
  {
    title: "Travel",
    value: "Travel Prep",
  },
  {
    title: "Student Connect",
    value: "Connect With Senior",
  },
];

export const AreasOfHelp = ({ selectedOptions, setSelectedOptions }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px" }}>What support would you like?</Title>
      <Flex wrap>
        <MultiSelectTitleCardsList
          options={allAreasOfHelp}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
        />
      </Flex>
    </Flex>
  );
};
